export default __webpack_public_path__ + "66ebb701750b70ea175f9b2b848486be.png";